import { styled } from "baseui";
import { FlexGrid, FlexGridItem } from "baseui/flex-grid";

export const MainContainer = styled(FlexGrid, ({ $theme }) => ({
  height: "100vh",
  alignItems: "center", // This will center the grid items horizontally within each grid row.
  justifyContent: "center", // This will center the grid itself within the viewport along the main axis.
  background: `
    radial-gradient(circle at 10% 20%, ${$theme.colors.primary600}, transparent),
    radial-gradient(circle at 90% 80%, ${$theme.colors.accent}, transparent),
    ${$theme.colors.backgroundPrimary}
  `,
  backgroundSize: "cover",
  backgroundPosition: "center center",
  // backgroundRepeat: "no-repeat",
  // Make sure you have the following property to layout grid items in a column fashion
  flexDirection: "column",
}));
export const FormContainer = styled(FlexGrid, ({ $theme }) => ({
  maxWidth: "500px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: $theme.sizing.scale600,
}));
export const LogoContainer = styled(FlexGridItem, ({ $theme }) => ({
  width: "100%",
  height: 'scale500',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const InputContainer = styled(FlexGridItem, ({ $theme }) => ({
  maxWidth: "400px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: $theme.sizing.scale600,
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  borderRadius: "20px",
}));
